export default __webpack_public_path__ + "static/topic17-62c4bf6d0b116e3a94b489a8bb41dee9.png";